export default "__VITE_ASSET__CYeJQM_u__"